import forgetPasswordPage from './pages/forgetPassword'
import summerCampPage from './pages/summerCamp'
import examExempted from './pages/examExempted'
import doctor from './pages/doctor'
import unifiedexamination from './pages/unifiedexamination'
import unifieddoctor from './pages/unifieddoctor'
import contact from './pages/contact'
import examDoctor from './pages/examDoctor'
import directory from './pages/directory'
import homeIndex from './pages/homeIndex'
import apply from './pages/apply'
const pageRouters = [
  homeIndex,
  forgetPasswordPage,
  summerCampPage,
  examExempted,
  doctor,
  unifiedexamination,
  unifieddoctor,
  contact,
  examDoctor,
  directory,
  apply
]
export default pageRouters



// WEBPACK FOOTER //
// ./src/router/pageRouters.js